// extracted by mini-css-extract-plugin
export var label = "_iq-0";
export var treatmentCard = "_iq-1";